import React__default from 'react';

var ContactTitleAndCompany = function ContactTitleAndCompany(_ref) {
  var title = _ref.title,
    company = _ref.company,
    companyLinkComponent = _ref.companyLinkComponent;
  var companyLine = company ? /*#__PURE__*/React__default.createElement("p", {
    className: "line-clamp-2",
    title: company
  }, company) : null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col",
    "automation-id": "contact-card-title-and-company"
  }, title && /*#__PURE__*/React__default.createElement("p", {
    className: "line-clamp-3",
    title: title
  }, title), company && companyLinkComponent ? companyLinkComponent : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, companyLine));
};

export { ContactTitleAndCompany };
//# sourceMappingURL=contact-title-and-company.esm.js.map
